import React, { useState, useEffect } from "react";
import "./userList.css";
import logoBlue from "../../components/images/logoblue.png";
import { Link, useHistory } from "react-router-dom";
import {
  ArrowBack,
  ArrowForward,
  AccountCircleOutlined,
} from "@material-ui/icons";
import { getUsers } from "../../services/user.services";

import { useDispatch, useSelector } from "react-redux";
import { fetchUserList } from "../../redux/actions/getUserListAction";

export default function UserList(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const userData = useSelector((state) => state.userList.userList); 
  const loading = useSelector((state) => state.loading);

  useEffect(() => {
    dispatch(fetchUserList());
  }, [dispatch]);

  if (loading) {
    return <p>Loading...</p>; 
  }

  return (
    <div className="userList">
      <div className="userListHeader">
        <div className="titleWithBack">
          <button className="backBtn" onClick={() => history.goBack()}>
            <ArrowBack className="backBtnIcon" />
          </button>
          <h1 className="userListTitle">All Users</h1>
        </div>
        <img className="userListLogo" src={logoBlue} alt="logo" width="150px" />
      </div>

      {userData && userData.map((item) => (
        <div key={item._id} className="userListContainer">
          <div>
            <AccountCircleOutlined className="userListImg" />
          </div>

          <div className="userAgeView">
            <p className="userListUserName">{item.userName}</p>
            <div className="line" />
            <p className="userListUserEmail">{item.email}</p>
          </div>

          <Link to={"/User/" + item._id}>
            <button className="fwdBtn">
              <ArrowForward className="fwdBtnIcon" sx={{ fontSize: 50 }} />
            </button>
          </Link>
        </div>
      ))}
    </div>
  );
}